module.exports = __webpack_public_path__ + "img/360se-5.ba473f32.png";